

import { Component, Vue, Prop ,Watch} from 'vue-property-decorator';
import {
  getOrderCheckSettingList,
} from '@/api/orderCheck';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'OrderCheckFlowInfo',
})
export default class extends Vue {
    @Prop({
    type: Boolean,
    default: false
  })
  dialogVisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({customer_company_id:0,group_id:0}),
    required: true
  })
  orderCheck!: {customer_company_id:0,group_id:0};

  private list: any = null;


  @Watch('orderCheck', {
     deep: true,
     immediate: true
   })
  orderCheckChangeProps() {
      this.getProgressList()
  }


  created() {
    this.getProgressList()
  }
  private getProgressList() {
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.user_name = UserModule.getUserName;
    p.customer_company_id = this.orderCheck.customer_company_id;
    p.group_id = this.orderCheck.group_id;
    getOrderCheckSettingList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
            this.list = data.list;
        } else {
            this.list = [];
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg(msg)
      });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }


}
